import React, { useEffect, useState } from 'react';
import { API_URLS } from '../../apiUrl';
import { Pagination } from '@mui/material';
import SurveyorEdit from '../../editModals/surveyorEdit';
import { toast, ToastContainer } from 'react-toastify';
import axiosInstance from '../../components/axiosInstance';

const ViewSurveyer = ({ municipalityId, roleId }: any) => {
  const [tableData, setTableData] = useState<any[]>([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [itemsPerPage] = useState(10);
  const [loading, setLoading] = useState(false);
  const [inputData, setInputData] = useState({ page: 1, limit: 10 });
  const [totalItems, setTotalItems] = useState(0);

  const filteredData = tableData?.filter((item: any) => {
    const statusLabel = item.status === 1 ? 'active' : item.status === 2 ? 'inactive' : '';
  
    return (
      item.survyer_name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
      item.municipality_name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
      item.borough_names?.toLowerCase().includes(searchQuery.toLowerCase()) ||
      item.ward_no?.toLowerCase().includes(searchQuery.toLowerCase()) ||
      item.street_names?.toLowerCase().includes(searchQuery.toLowerCase()) ||
      statusLabel.includes(searchQuery.toLowerCase())
    );
  });

  const totalPages = Math.ceil(totalItems / itemsPerPage);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await axiosInstance.post(`${API_URLS.ListSurveyor}`, {
          page: inputData.page,
          limit: inputData.limit,
          municipality_id: municipalityId
        });

        if (response.data && response.data.data) {
          setTableData(response.data.data.data);
          setTotalItems(response.data.data.total);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [inputData.page, municipalityId]);

  const handlePageChange = (event: any, value: number) => {
    setInputData((prevData) => ({
      ...prevData,
      page: value,
    }));
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [streetId, setStreetId] = useState<any>("");
  const [boroughId, setBoroughId] = useState<any>("");
  const [surveyorName, setSurveyorName] = useState<any>("");
  const [surveyorId, setSurveyorId] = useState<any>("");
  const [loginUserName, setLoginUserName] = useState<any>("");
  const [password, setPassword] = useState<any>("");
  const [wardId, setWardId] = useState<any>("");

  const openModal = (surveyorName: any, surveyorId: any, loginUserName: any, password: any, boroughId: any, wardId: any, streetId: any) => {
    setIsModalOpen(true);
    setSurveyorName(surveyorName);
    setSurveyorId(surveyorId);
    setLoginUserName(loginUserName);
    setPassword(password);
    setWardId(wardId);
    setStreetId(streetId);
    setBoroughId(boroughId);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const [animatingItems, setAnimatingItems] = useState<{ [key: number]: boolean }>({});

  const toggleStatus = async (id: number, currentStatus: number) => {
    setAnimatingItems((prev) => ({ ...prev, [id]: true }));
    const newStatus = currentStatus === 1 ? 2 : 1;

    setTableData((prevData: any) =>
      prevData.map((item: any) =>
        item.surveyer_id === id ? { ...item, status: newStatus } : item
      )
    );

    try {
      const response = await axiosInstance.post(`${API_URLS.SurveyorStatus}`, {
        surveyor_id: id,
        status: newStatus
      });

      if (response.data.message == "surveyor status updated successfully") {
        toast.success('Status updated successfully!');
      } else {
        toast.error('Failed to update status.');
      }
    } catch (error) {
      console.error('Error updating status:', error);
      toast.error('Failed to update status.');
    } finally {
      setTimeout(() => {
        setAnimatingItems((prev) => ({ ...prev, [id]: false }));
      }, 300);
    }
  };

  return (
    <div className="container mx-auto">
      <ToastContainer />
      <div className="flex gap-5 mb-4">
        <h1 className="text-2xl font-semibold text-gray-800 dark:text-gray-100">Surveyor Administration</h1>
        <div className="flex justify-end md:w-4/12 w-full ml-auto">
          <input
            type="text"
            placeholder="Search..."
            className="border px-3 py-2 rounded-lg w-full text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 dark:border-gray-900 dark:bg-gray-800"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </div>
      </div>

      <div className="overflow-x-auto bg-white rounded-lg shadow-lg border border-gray-200 dark:border-gray-800">
        <table className="min-w-full table-auto">
          <thead className="bg-gray-100 border-b dark:border-gray-600 dark:bg-gray-700">
            <tr>
              <th className="py-3 px-6 text-left text-sm font-medium text-gray-600 dark:text-gray-100">Surveyor Name</th>
              <th className="py-3 px-6 text-left text-sm font-medium text-gray-600 dark:text-gray-100">Municipality</th>
              <th className="py-3 px-6 text-left text-sm font-medium text-gray-600 dark:text-gray-100">Borough Name</th>
              <th className="py-3 px-6 text-left text-sm font-medium text-gray-600 dark:text-gray-100">Ward No.</th>
              <th className="py-3 px-6 text-left text-sm font-medium text-gray-600 dark:text-gray-100">Street Names</th>
              <th className="py-3 px-6 text-center text-sm font-medium text-gray-600 dark:text-gray-100">Status</th>
              <th className="py-3 px-6 text-center text-sm font-medium text-gray-600 dark:text-gray-100">Actions</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan={7} className="py-3 px-6 text-center dark:bg-gray-800">Loading...</td>
              </tr>
            ) : filteredData.length === 0 ? (
              <tr>
                <td colSpan={7} className="py-3 px-6 text-center dark:bg-gray-800">No results found</td>
              </tr>
            ) : (
              filteredData.map((item: any, index: number) => (
                <tr key={index} className="border-b dark:border-gray-700 hover:bg-gray-50">
                  <td className="py-3 px-6 text-sm text-gray-800 dark:text-gray-200 dark:bg-gray-600">{item.survyer_name || 'N/A'}</td>
                  <td className="py-3 px-6 text-sm text-gray-800 dark:text-gray-200 dark:bg-gray-600">{item.municipality_name || 'N/A'}</td>
                  <td className="py-3 px-6 text-sm text-gray-800 dark:text-gray-200 dark:bg-gray-600">{item.borough_names || 'N/A'}</td>
                  <td className="py-3 px-6 text-sm text-gray-800 dark:text-gray-200 dark:bg-gray-600">{item.ward_no || '-'}</td>
                  <td className="py-3 px-6 text-sm text-gray-800 dark:text-gray-200 dark:bg-gray-600">{item.street_names || '-'}</td>
                  <td className="py-3 px-6 text-sm text-center">
                    <button
                      onClick={() => toggleStatus(item.surveyer_id, item.status)}
                      className={`inline-block px-3 py-1 text-xs font-medium rounded-full border ${item.status === 1 ? 'text-green-500 border-green-200 bg-green-100' : 'text-red-500 border-red-200 bg-red-100'} ${animatingItems[item.surveyer_id] ? 'status-change' : ''}`}
                    >
                      {item.status === 1 ? 'Active' : 'Inactive'}
                    </button>
                  </td>
                  <td className="py-3 px-6 text-sm text-gray-800 dark:text-gray-200 dark:bg-gray-600 text-center">
                    <div className="flex gap-2 justify-center">
                      <button 
                        onClick={() => openModal(item.survyer_name, item.surveyer_id, item.login_user_name, item.password, item.borough_ids, item.ward_ids, item.street_ids)}
                        className="px-2 py-1.5 text-green-500 border border-green-200 rounded bg-green-100 hover:bg-green-200"
                      >
                        <i className="ri-edit-line"></i>
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {filteredData.length > 0 && (
        <div className="flex justify-center mt-4">
          <Pagination
            count={totalPages}
            page={inputData.page}
            onChange={handlePageChange}
            color="primary"
          />
        </div>
      )}

      <SurveyorEdit 
        isOpen={isModalOpen} 
        closeModal={closeModal} 
        municipalityId={municipalityId} 
        surveyorName={surveyorName} 
        surveyorId={surveyorId} 
        loginUserName={loginUserName} 
        password={password} 
        boroughId={boroughId} 
        wardId={wardId} 
        streetId={streetId} 
      />
    </div>
  );
};

export default ViewSurveyer;